import { useQuery } from "react-query";
import { http } from "src/api/http";
import { MonitorRecord } from "./models";

export function useAuthMonitor() {
  return useQuery<MonitorRecord[]>(["/api/admin/auth-app-monitor"], () => http("/api/admin/auth-app-monitor"))
}